import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Hero: React.FC = () => {
  const { t } = useTranslation();
  const [videoReady, setVideoReady] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <section className="hero">
      <div className="hero-video-container">
        {!videoReady && (
          <img
            src="/images/homepage.png"
            alt=""
            className="hero-video"
            style={{ objectFit: 'cover' }}
          />
        )}
        <video
          ref={videoRef}
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
          onCanPlay={() => setVideoReady(true)}
          style={{ display: videoReady ? 'block' : 'none' }}
        >
          <source src="/videos/hero-scenic.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">{t('hero.title')}</h1>
        <p className="hero-subtitle">{t('hero.subtitle')}</p>
        <div className="hero-buttons">
          <a href="https://flow.cypressera.ai" target="_blank" rel="noopener noreferrer" className="hero-button primary">{t('hero.tryNow')}</a>
          <button className="hero-button secondary" onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}>{t('hero.exploreMore')}</button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
